import { LuciaPaymentsPage } from '@auteco/pages'
import React from 'react'

const LuciaPaymentsContainer = () => {
    return (
        <LuciaPaymentsPage />
    )
}

export { LuciaPaymentsContainer }